import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PERSON_API_SERVICE_TOKEN } from '@nk/api-lib';
import { GenderEntity, WithUuid } from '@nk/data-entities-lib';
import { GENDER_TRANSLATIONS } from '@nk/person-block';
import { Dict } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'nk-gender',
  imports: [AsyncPipe, TranslateModule],
  templateUrl: './gender.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenderComponent implements OnInit {
  public genderUuid = input.required<string>();
  public genderDict$!: Observable<Dict<WithUuid<GenderEntity>>>;
  public genderTranslations = GENDER_TRANSLATIONS;
  private _personService = inject(PERSON_API_SERVICE_TOKEN);

  public ngOnInit(): void {
    this.genderDict$ = this._personService.genderListCache.getStableCache().pipe(
      map((data) =>
        data.reduce((res: Dict<WithUuid<GenderEntity>>, i) => {
          res[i.uuid] = i;
          return res;
        }, {}),
      ),
    );
  }
}
